import { useEffect } from 'react'

const useSetSinkIdPolyfill = () => {
  // Polyfill for setSinkId.
  useEffect(() => {
    if (!('setSinkId' in HTMLAudioElement.prototype)) {
      ;(HTMLAudioElement.prototype as any).setSinkId = () => {}
    }
  }, [])
}

export default useSetSinkIdPolyfill
